import { Settings } from "lucide-react";
import { ReactComponent as CostIcon } from "../../../assets/icons/bill.svg";
import { ReactComponent as CardIcon } from "../../../assets/icons/card.svg";
import { ReactComponent as IncidentIcon } from "../../../assets/icons/Caution.svg";
import { ReactComponent as DashboardIcon } from "../../../assets/icons/dash.svg";
import { ReactComponent as FuelIcon } from "../../../assets/icons/gas.svg";
import { ReactComponent as ProfileIcon } from "../../../assets/icons/profile.svg";
import { ReactComponent as ToolsIcon } from "../../../assets/icons/tool.svg";
import { ReactComponent as TruckIcon } from "../../../assets/icons/truck.svg";
import { ReactComponent as DriverIcon } from "../../../assets/icons/two-user.svg";
import { ReactComponent as GroupIcon } from "../../../assets/icons/user-group.svg";

export interface NavItem {
  id: string;
  name: string;
  permissionName: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  subItems?: SubNavItem[];
}

export interface SubNavItem {
  id: string;
  name: string;
  permissionName: string;
  icon?: React.ComponentType<any>;
}

export const navItems: NavItem[] = [
  {
    id: "",
    name: "Dashboard",
    permissionName: "Dashboard",
    icon: DashboardIcon,
  },
  {
    id: "vehicles",
    name: "Vehicles",
    permissionName: "Vehicles",
    icon: TruckIcon,
    subItems: [
      {
        id: "vehicles",
        name: "All vehicles",
        permissionName: "Vehicles",
      },
      {
        id: "vehicle-assignments",
        name: "Vehicle assignment",
        permissionName: "VehicleAssignments",
      },
      {
        id: "on-going-trips",
        name: "Ongoing trip",
        permissionName: "Dispatch",
      },
      {
        id: "dispatch-import",
        name: "Dispatch import",
        permissionName: "Dispatch",
      },
    ],
  },
  {
    id: "drivers",
    name: "Drivers",
    permissionName: "Company",
    icon: DriverIcon,
    subItems: [
      {
        id: "drivers",
        name: "All drivers",
        permissionName: "Company",
      },
      {
        id: "crew-members",
        name: "Crew members",
        permissionName: "Company",
      },
      {
        id: "fines",
        name: "Fines",
        permissionName: "Company",
      },
    ],
  },
  {
    id: "partners",
    name: "Partners",
    permissionName: "Company",
    icon: GroupIcon,
  },
  {
    id: "maintenance",
    name: "Maintenance",
    permissionName: "Maintenance",
    icon: ToolsIcon,
  },
  {
    id: "fuel",
    name: "Fuel",
    permissionName: "Maintenance",
    icon: FuelIcon,
  },
  {
    id: "requisition",
    name: "Requisition",
    permissionName: "Requisition",
    icon: CardIcon,
  },
  // {
  //   id: "inventory",
  //   name: "Inventory",
  //   permissionName: "Maintenance",
  //   icon: InventoryIcon,
  // },
  {
    id: "finance",
    name: "Finance",
    permissionName: "Company",
    icon: CostIcon,
  },
  {
    id: "incident-report",
    name: "Incident report",
    permissionName: "Company",
    icon: IncidentIcon,
  },
  {
    id: "users",
    name: "User management",
    permissionName: "Users",
    icon: ProfileIcon,
  },
  {
    id: "settings",
    name: "Settings",
    permissionName: "Company",
    icon: Settings,
  },
];
